import { graphql } from '../../graphql/generated';

export const OpenRequestsBySvnrModalRequestFragment = graphql(`
  fragment OpenRequestsBySvnrModal_Request on Request {
    id
    createdAt
    orders {
      id
      orderParameters {
        id
        shortName
        longName
      }
    }
  }
`);
